import _implicitStylesheets from "./moreResources.css";
import _implicitScopedStylesheets from "./moreResources.scoped.css?scoped=true";
import _listingMoreResourcesSection from "listing/moreResourcesSection";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6" class="title${0}"${2}>${"t1"}</h3>`;
const stc0 = {
  attrs: {
    "grid": "",
    "align-items": "spread",
    "axis": "row",
    "flow": "wrap",
    "gap": "x-large",
    "row-gap": "x-large"
  },
  key: 2
};
const stc1 = {
  attrs: {
    "grid": "",
    "size": "1:1@small 1:2@medium 1:3@large",
    "axis": "column"
  },
  key: 3
};
const stc2 = {
  attrs: {
    "grid": "",
    "size": "1:1@small 1:2@medium 1:3@large",
    "axis": "column"
  },
  key: 5
};
const stc3 = {
  attrs: {
    "grid": "",
    "size": "1:1@small 1:2@medium 1:3@large",
    "axis": "column"
  },
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, c: api_custom_element, i: api_iterator, h: api_element} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(1, null, api_dynamic_text($cmp.title))]), api_element("div", stc0, [api_element("div", stc1, api_iterator($cmp.colOneSections, function (resourceSection) {
    return api_custom_element("listing-more-resources-section", _listingMoreResourcesSection, {
      props: {
        "resourceSection": resourceSection
      },
      key: api_key(4, resourceSection.type)
    });
  })), api_element("div", stc2, api_iterator($cmp.colTwoSections, function (resourceSection) {
    return api_custom_element("listing-more-resources-section", _listingMoreResourcesSection, {
      props: {
        "resourceSection": resourceSection
      },
      key: api_key(6, resourceSection.type)
    });
  })), api_element("div", stc3, api_iterator($cmp.colThreeSections, function (resourceSection) {
    return api_custom_element("listing-more-resources-section", _listingMoreResourcesSection, {
      props: {
        "resourceSection": resourceSection
      },
      key: api_key(8, resourceSection.type)
    });
  }))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2bg2ou0vefq";
tmpl.legacyStylesheetToken = "undefined-_moreResources";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
